export const PRESENCE_STATUS = {
  AUTOMATIC: 0,
  ONLINE: 1,
  ACTIVE: 2,
  DO_NOT_DISTURB: 3,
  AWAY: 4,
  BUSY: 5,
  BE_RIGHT_BACK: 6,
  OFFLINE: 7,
  OUT_OF_OFFICE: 8,
};

export const PRESENCE_STATUS_LABEL = {
  [PRESENCE_STATUS.AUTOMATIC]: 'Automatic',
  [PRESENCE_STATUS.ONLINE]: 'Online',
  [PRESENCE_STATUS.ACTIVE]: 'Active',
  [PRESENCE_STATUS.DO_NOT_DISTURB]: 'Do not disturb',
  [PRESENCE_STATUS.AWAY]: 'Away',
  [PRESENCE_STATUS.BUSY]: 'Busy',
  [PRESENCE_STATUS.BE_RIGHT_BACK]: 'Be right back',
  [PRESENCE_STATUS.OFFLINE]: 'Offline',
  [PRESENCE_STATUS.OUT_OF_OFFICE]: 'Out of office',
};

export const PRESENCE_TYPE = {
  ONLINE: 'online',
  BUSY: 'busy',
  DO_NOT_DISTURB: 'dnd',
  AWAY: 'away',
  OFFLINE: 'offline',
};

export const PRESENCE_INTERVAL = 30 * 1000;